import update from "immutability-helper";
import { createSlice } from "@reduxjs/toolkit";

import { appendSorted, sortByCreatedAtStable } from "./messagesUtils";

const initialState = {
  data: [],
  pending: true,
  links: {
    first: "",
    last: "",
    prev: null,
    next: null,
  },
  meta: {
    current_page: 0,
    from: 1,
    last_page: 0,
    links: [],
    path: "",
    per_page: 15,
  },
};

export const messageSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setMessagesPending: (state, action) => {
      return update(state, {
        pending: {
          $set: true,
        },
      });
    },
    setLastPage: (state, action) => {
      return update(state, {
        pending: {
          $set: false,
        },
        meta: {
          last_page: {
            $set: action.payload,
          },
        },
      });
    },
    pushMessages: (state, action) => {
      // If a message in payload does not contain data property,
      // then is considered created by the user or by the socket channel.
      if (!action.payload.data) {
        // An optimistic send has no id yet -- sendMessageSuccess assigns one later.
        const hasRealId = action.payload.id !== undefined && action.payload.id !== null;
        const alreadyPresent =
          hasRealId && state.data.some((message) => message.id === action.payload.id);
        if (alreadyPresent) {
          return state;
        }

        return update(state, {
          pending: {
            $set: false,
          },
          data: {
            $set: appendSorted(state.data, action.payload),
          },
        });
        // Else messages are considered as incoming.
      } else {
        const messagesPayloadIds = new Set(state.data.map((message) => message.id));
        const incomingMessages = action.payload.data.filter(
          (message) => !messagesPayloadIds.has(message.id)
        );

        const mergedMessages = sortByCreatedAtStable(state.data.concat(incomingMessages));

        return update(state, {
          pending: {
            $set: false,
          },
          meta: {
            $set: action.payload.meta,
          },
          data: {
            $set: mergedMessages,
          },
        });
      }
    },
    sendMessageSuccess: (state, action) => {
      const { id, clientId, created_at } = action.payload;
      const messageIndex = state.data.findIndex((message) => message.clientId === clientId);
      if (messageIndex === -1) return state;

      return update(state, {
        data: {
          [messageIndex]: {
            id: {
              $set: id,
            },
            isPending: {
              $set: false,
            },
            created_at: {
              $set: created_at ?? state.data[messageIndex].created_at,
            },
          },
        },
      });
    },
    clearMessages: () => {
      return initialState;
    },
  },
});

export const { setMessagesPending, pushMessages, setLastPage, sendMessageSuccess, clearMessages } =
  messageSlice.actions;

export default messageSlice.reducer;
